<script setup>
const { init } = useThemeToggle()
init()
</script>

<template>
  <v-app>
    <MainNavbar />
    <slot />
    <ScrollToTop />
    <MainFooter />
  </v-app>
</template>
